import { render, staticRenderFns } from "./NotifyUser.vue?vue&type=template&id=0750c411&"
import script from "./NotifyUser.vue?vue&type=script&lang=js&"
export * from "./NotifyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports